import React from "react";
import SquircleIcon from "@/shared/components/ui/SquircleIcon";
import Search from "@/assets/svg/Search";
import TrialRemainingCount from "@/shared/components/ui/TrialRemainingCount";
import type { ProspectPageTab } from "../types";

const SquircleIconComponent = SquircleIcon as React.ComponentType<any>;
const SearchIcon = Search as React.ComponentType<any>;
const TrialCount = TrialRemainingCount as React.ComponentType<{ resource: string }>;

const HEADER_COPY = {
  contacts: {
    title: "Find New Contacts",
    subtitle: "Search for decision makers and leads matching your ideal customer profile",
  },
  accounts: {
    title: "Find New Accounts",
    subtitle: "Find new companies or surface ones already showing activity",
  },
} as const;

/** Same title row as Account Discovery (icon, title, subtitle on one line), without the breadcrumb. */
export default function ProspectPageHeader({ tab }: { tab: ProspectPageTab }) {
  const { title, subtitle } = HEADER_COPY[tab];
  return (
    <div className="pl-6 pr-3 w-full flex items-center gap-3">
      <SquircleIconComponent>
        <SearchIcon />
      </SquircleIconComponent>
      <div className="text-base font-medium font-sans text-black dark:text-white">{title}</div>
      <p className="text-sm font-normal text-gray-500 dark:text-gray-400">{subtitle}</p>
      {/* Trial accounts: what is left of the quotas this tab uses (nothing for paid users). */}
      <div className="ml-auto flex items-center gap-2">
        <TrialCount resource={tab === "contacts" ? "contacts" : "accounts"} />
      </div>
    </div>
  );
}
